interface ColumnTitlesProps {
    translate: (key: string) => string;
    isSelectAllEnabled: boolean;
    checked: boolean;
    onSelectAllCheckPress: (checked: boolean) => void;
}

const columnTitles = ({
    translate,
    isSelectAllEnabled,
    checked,
    onSelectAllCheckPress
}: ColumnTitlesProps): any[] => [
    {
        label: '',
        showSelectAllCheck: true,
        checked,
        isSelectAllEnabled,
        onSelectAllCheckPress
    },
    translate('table.columnsTitles.name'),
    translate('table.columnsTitles.contract'),
    translate('table.columnsTitles.establishment'),
    translate('table.columnsTitles.presentationDate'),
    translate('table.columnsTitles.stateSRT'),
    translate('table.columnsTitles.generationDate'),
    translate('table.columnsTitles.actions')
];

const columnWidths = [...[], '5%', '5%', '25%', '25%', '15%', '15%', '5%'];

export { columnTitles, columnWidths };
